
import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react'
import SummaryAulas from './SummaryAulas';
import linkEmbed from '../../../../utils';
import { useUserStorage } from '../../../../storage/user';

export default function AulasInfo({ selectedCurso }) {

    const [value, setValue] = useState('one');

    const { setSelectedAula } = useUserStorage(state => state.dispatch)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [yout, setYout] = useState('')

    useEffect(() => { 
        document.getElementById('textInfo').innerHTML = selectedCurso?.info
 
        const link = linkEmbed(selectedCurso?.video_principal)
 
        setYout(link)
    }, [selectedCurso])

    return (
        <div style={{ padding: '0 20px' }}>
            <iframe style={{ width: '100%', minHeight: '400px' }}
                src={yout} /* {"https://www.youtube.com/embed/9jzs5S-tnHw?si=m7cdenN-MjAbW2BX"} */
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>

            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="wrapped label tabs example"
                >
                    <Tab
                        value="one"
                        label="Informações do curso"
                        wrapped
                    />
                    <Tab value="two" label="Avaliações" />
                </Tabs>
            </Box>

            {
                value === 'one' && <>
                    <h2 style={{ marginTop: '20px' }}>Conteúdo do curso</h2>
                    <div id='textInfo' style={{ marginTop: '10px' }}>


                    </div>

                    {
                        selectedCurso && selectedCurso?.modulos?.map(item => {
                            return (
                                <SummaryAulas item={item} setSelectedAula={setSelectedAula} />
                            )
                        })
                    }
                </>

            }

            {
                value === 'two' &&
                <div style={{ height: '500px' }}>
                </div>
            }




        </div>
    )
}
